import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/services/authentication.service';
import { UserService } from '@core/services/user.service';
import { log } from 'node:console';

@Component({
    selector: 'app-authentication',
    imports: [],
    templateUrl: './authentication.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './authentication.component.scss'
})
export class AuthenticationComponent {

  constructor(
    private activatedRoute: ActivatedRoute,
    private authSvc: AuthenticationService,
    private userSvc: UserService
  ) {
        
    /* this.activatedRoute.queryParamMap.subscribe(params => {
      let _paramToken = params.get('token');

      if (_paramToken) {
        this.authSvc.setToken(_paramToken);
        this.authSvc.userToken = _paramToken;
        this.userSvc.getUserAuthenticated();
      }
    }); */

    this.activatedRoute.fragment.subscribe(fragment => {
      if (fragment) {
        const params = new URLSearchParams(fragment);
        const _paramToken = params.get('token');
        
        if (_paramToken) {
          this.authSvc.setToken(_paramToken);
          this.authSvc.userToken = _paramToken;
          this.userSvc.getUserAuthenticated();
        }
      }
    });
  }
}
